<mat-dialog-content class="modal-header"
  ><h2 mat-dialog-title>CÓDIGO DE ACCESO</h2></mat-dialog-content
>

<mat-dialog-content class="modal-body">
     <div class="block-content">
          <div class="form-horizontal">
               <div class="form-group" align="center">
                    <img [src]="imageToShow"
                    alt="Place image title"
                    *ngIf="!isImageLoading; else noImageFound">
               <ng-template #noImageFound>
                    <img src="fallbackImage.png" alt="Fallbackimage">
               </ng-template>
               </div>
          </div>
     </div>
</mat-dialog-content>

   <mat-dialog-actions align="center" class="modal-actions">
     <button class="btn btn-naranja" mat-button><mat-icon>print</mat-icon> Imprimir</button>
     <button class="btn btn-naranja2" mat-button (click)="onNoClick()"><mat-icon>exit_to_app</mat-icon> Cancelar</button>
   </mat-dialog-actions>


